import { render, staticRenderFns } from "./Note.vue?vue&type=template&id=1313501e&scoped=true&"
import script from "./Note.vue?vue&type=script&lang=ts&"
export * from "./Note.vue?vue&type=script&lang=ts&"
import style0 from "./Note.vue?vue&type=style&index=0&id=1313501e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1313501e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
